import React, { Component, Fragment } from 'react'
import FullpageError from 'pobble-components/dist/full-page-error'
import Button from 'pobble-components/dist/button'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    console.error(error)
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <FullpageError
          monster="unplug"
          title="There appears to be a technical error"
          button={
            <Button action={() => window.location.reload()} tall>
              Reload the page
            </Button>
          }
          desc={
            <Fragment>
              If this continues to happen, please
              <br />
              contact hello@pobble.com.
            </Fragment>
          }
          status="Oops!"
        />
      )
    }

    return this.props.children
  }
}

export { ErrorBoundary }
